import { Injectable } from '@angular/core';
import { DefaultConfigService } from './default-configs/services/default-config.service';
import { Observable, of } from 'rxjs';
import { IDefaultConfig } from './default-configs/models/i-default-config';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DefaultGridConfigService {
 private readonly configPrefix = 'defaultGridConfig-';

  constructor(private defaultConfigService: DefaultConfigService) {}

  getDefaultGridConfig(gridId: string): Observable<any> {
    const configName = `${this.configPrefix}${gridId}`;
    return this.defaultConfigService.getConfigByName(configName).pipe(
      map((config: IDefaultConfig) => config?.value || null),
      catchError(() => of(null)) // Return null if config doesn't exist
    );
  }

  saveDefaultGridConfig(gridId: string, config: any): Observable<{ success: boolean }> {
    const configName = `${this.configPrefix}${gridId}`;
    const userConfig: IDefaultConfig = {
      name: configName,
      value: config
    };

    return this.defaultConfigService.saveConfig(userConfig).pipe(
      map(() => ({ success: true })),
      catchError((error) => {
        console.error('Error saving grid config:', error);
        return of({ success: false });
      })
    );
  }

  deleteDefaultGridConfig(gridId: string): Observable<{ success: boolean }> {
    const configName = `${this.configPrefix}${gridId}`;
    return this.defaultConfigService.deleteConfig({ name: configName }).pipe(
      map(() => ({ success: true })),
      catchError((error) => {
        console.error('Error deleting grid config:', error);
        return of({ success: false });
      })
    );
  }
}
